import { useInvoice } from "../hooks/useInvoice";

const InvoiceDetail = () => {
  const { invoice, id, currentStep } = useInvoice();
  return (
    <main className="invoice-container">
      <h1 className="text-muted">Summary</h1>
      <div className="divider"></div>

      <div className="amount-label text-muted">Total Amount</div>
      <div className="amount-row">
        <div className="amount">XOF {invoice?.amount}</div>
        {/* <div className="usd">USD 100.13</div> */}
      </div>

      <section className="card" aria-label="Invoice details">
        <div className="card-row">
          <div className="text-muted">Date</div>
          <div className="text-muted strong">
            {invoice?.created_at
              ? new Date(invoice?.created_at)?.toLocaleDateString()
              : "-"}
          </div>
        </div>
        <div className="card-row alt">
          <div className="text-muted">Invoice ID</div>
          <div className="text-muted strong">{id || "-"}</div>
        </div>
        <div className="card-row">
          <div className="text-muted">Business</div>
          <div className="text-muted strong">
            {invoice?.business_name || "-"}
          </div>
        </div>
      </section>

      <div className="divider" style={{ margin: "26px 0 0" }}></div>

      {invoice?.note && (
        <>
          <h2 className="text-muted">Description</h2>
          <p>{invoice?.note}</p>
        </>
      )}
      <h2 className="text-muted">Payment steps</h2>
      <ul className="steps">
        <li className={`step ${currentStep === 1 && "active"}`}>
          <span className="dot" aria-hidden="true"></span>
          <span>Enter Wallet number</span>
        </li>
        <li className={`step ${currentStep === 2 && "active"}`}>
          <span className="dot" aria-hidden="true"></span>
          <span>Verify OTP</span>
        </li>
        <li className={`step ${currentStep === 3 && "active"}`}>
          <span className="dot" aria-hidden="true"></span>
          <span>Confirm Payment</span>
        </li>
      </ul>
    </main>
  );
};

export default InvoiceDetail;
